export default "__VITE_ASSET__NV8EIo66__"